/**
 * Module-level mutable that tracks the runtime home env once /api/app-env
 * resolves. Extracted into its own module so tests that mock axiosClient
 * (which only stubs the default export) don't accidentally shadow this.
 *
 * axiosClient.ts reads via getHomeEnv(); useAppEnv.ts writes via setRuntimeHomeEnv().
 */

let runtimeHomeEnv: string | null = null;

/**
 * Wire once when /api/app-env resolves (called by useAppEnv on success).
 * After this call every axios interceptor reads the true runtime home env.
 */
export const setRuntimeHomeEnv = (env: string): void => {
  runtimeHomeEnv = env;
};

/** The effective home env: runtime (after app-env loads) or build-time fallback. */
export const getHomeEnv = (): string =>
  runtimeHomeEnv ?? (process.env.REACT_APP_EDITABLE_ENV ?? 'dev01');
